export default "__VITE_ASSET__Dm4HlFgP__"